import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
	header: {
		home:"首页",
		Classes:"普通课",
		Camps:"夏令营",
		Community:"社区",
		Calendar:"日历",
		Teachers:"老师",
		About:"关于我们",
		Cart:"购物车",
		login:"登录",
		success:"操作成功",
		check:"请勾选要操作的数据",
		FAQ:"Able2Shine客户常见问题",
		DASHBOARD:"仪表板",
		input:"请输入",
		select:"请选择",
		LOGOUT:"退出",
		confirm_delete:"确定退出吗？",
		confirm_del:"确定删除吗？",
		del_success:"删除成功",
		tips:"提示",
		resetPassword:"重置成功，请使用新密码",
		go_cart:"购物车",
		continue:"继续购物",
		upload_success:'上传成功',
	},
	index:{
		no_data:"没有数据了",
		promotion:'促销',
		learn:'学习中心',
		video:'视频',
		news:'新闻',
		events:'事件',
		user_name:'账号',
		password:'密码',
		p1:'忘记密码了',
		p2:'输入您的用户名或电子邮件地址，我们将向您发送一个链接来重置您的密码。',
		p3:'重置密码',
		FORGOT:'忘记密码',
		RESET:'重置密码',
		Back:'返回',
		categories:'课程类型',
		enter:'在此处输入产品标题。。。',
		view:'搜索',
		content:'发送内容',
		success:'发送成功',
		action:'操作',
	},
	footer:{
		Copyright:"版权所有©2021 Able2Shine。版权所有。",
	},
	navleft:{
		dashboard:"个人中心",
		course:"我的课程\n（包括長期私教课）",
		camp:"我的夏令营",
		private:"短期私教课",
		orders:"我的订单",
		orders_camps:"夏令营订单",
		account:"修改密码",
		friend:"邀请好友",
		credits:"学分",
		child:"学生信息",
		virtual:"虚拟班",
		information:"资讯中心",
		leave:"请假",
		edit:"设置",
		read:"全部已读",
		working_time:"工时统计",
		private_classes:"私教课时间",
		availability:"空闲时间",
	},
	member_courses:{
		syllabus:'教学大纲',
		course:'课程表',
		get_into:'进入',
		Reset:'重置',
		Search_bon:'搜索',
		ok:'确定',
	},
	member_index:{
		form:'列表',
		calendar:'日历',
		syllabus:'教学大纲',
		teacher:'教师',
		date:'日期',
		course:'课程表',
		student:'学生',
		children_status:'学生状态',
		status0:'未点名',
		status1:'已到',
		status2:'未到',
	},
	index_login:{
		h1:'登录以继续',	
		h2:'还不是会员？ ',
		h3:'立即注册',
		h4:'教师登录',
		username:'用户名',
		password:'密码',
		login:'立即登录',
		forgot:'忘记密码了',
	},
	virtual:{
		list:'课程列表',
		mail:'站内信',
		teacher_news:'老师交流',
		comment:'点评',
		task:'作业',
		hair_task:'留作业',
		upload_task:'交作业',
		batch_task:'批作业',
		course_assess:'课堂评估',
		course_assess_history:'课堂评估历史',
		certificate:'结业证书',
		feedback:'意见反馈',
		feedback_history:'意见反馈历史',
		on:'序号',
		time:'日期',
		course:'课程',
		status:'状态',
		leave:'请假',
		signin:'签到',
		course_name:'班级名称',
		teacher_name:'老师姓名',
		course_time:'上课时间',
		course_status:'课程状态',
		leave_history:'请假历史',
		del:'删除',
		edit:'编辑',
		return:'返回',
		all:'全部',
		unread:'未读',
		read:'已读',
		unread_quantity:'未读数量',
		teachers_index:'点名',
		teachers_index_history:'点名历史',
		teachers_task:'作业',
		teachers_parent:'家长交流',
		teachers_letter:'公/私信',
		teachers_letter_history:'公/私信历史',
		teachers_assess:'课堂评估',
		teachers_certificate:'结业证书',
		teachers_leave:'请假',
		operation:'操作',
		select:'全选',
		student:'学生',
		parent:'家长',
		submit:'提交',
		class_size:'班级人数',
		course_today:'今日课程',
		arrived_num:'已到人数',
		not_arrived_num:'未到人数',
		name:'标题',
		content:'内容',
		file_upload:'附件上传',
		add_file:'加附件',
		file:'附件',
		upload:'上传',
		download:'下载',
		time:'时间',
		reason:'理由',
		content_work:'批改内容',
		letter_type:'类型',
		children_id:'选择学生',
		send:'发送',
		score:'评分',
		assessment:'评估',
		debate_assessment:'辩论评估表',
		issue_certificate:'颁发证书',
		notes:'教师笔记',
		upload_video:'上传附件<20MB',
		upload_link:'附件链接>20MB',
		ok:'确定',
		student_name:'学生姓名',
		p_tishi:'*上传附件（文件大小<20MB）或使用附件链接',
		sound:'录音',
		recording_upload:'录音上传',
		duration:'录音时长',
		play_duration:'录音时长',
		start_recording:'开始录音',
		re_record:'重新录音',
		suspend_recording:'暂停录音',
		continue_recording:'继续录音',
		stop_recording:'停止录音',
		play_recording:'播放录音',
		pause_playback:'暂停播放',
		continue_playing:'继续播放',
		stop_playing:'停止播放',
		cancel:'取消',
		recording_error:'请先允许该网页使用麦克风',
		not_written:'学生还没有上传作业',
		teacher_tips:'请选择学生开始聊天',
		upload_succeeded:'上传成功',
		link:'教案链接',
		download:'预览',
		zoom:'上课链接',
		center_name:'上课地址',
		user_tel:'家长电话',
		grade:'年级',
		age:'年龄',
		fields:'自定义字段',
        trial_substitute:'试听/补课',
        trial_listening:'试听',
        substitute:'补课',
        remark:'备注',
        evaluation:'评估表',
	},
	assess:{
		title:'听、说、读、写综合课程，增强年轻人的信心和领导力灯光、相机、行动！',
		student:'学生',
		teacher:'老师',
		class:'课程',
		location:'学习中心',
		time:'上课时间',
		session:'学期',
		notes:'教师评语',
		table_statistics:'评估表统计',
		sound:'教师录音',
	},
	student:{
		name:'评估表名称',
		status:'状态',
		reason:'驳回理由',
		date:'时间',
		teacher:'老师',
		operator:'操作人',
		reject:'驳回',
	},
	working_time:{
		course:'课程名称',
		class_num:'课次',
		should:'应填写评测表',
		already:'已填写评测表',
	},
	member_account:{
		confirm:'确认提交',
		old_password:'旧密码',
		new_password:'新密码',
		confirm_password:'确认密码',
		rules_old:'请输入旧密码',
		rules_new:'请输入新密码',
		rules_confirm:'两次密码不一致',
	},
	private_classes:{
		course_time:'常规课时间',
		course_date:'上课时间',
		course_name:'主题',
		private_free_date:'添加私教课空闲时间',
		time_length:'时长',
		rest_time:'休息时长',
		start_time:'开始时间',
		end_time:'结束时间',
		all:'全部可上课时间',
		sold:'已售课程',
        purchased:'已购买',
        confirmed:'已确认',
        cannot_delete:'已经售卖不可删除',
        free_time:'空闲时间',
        end_date:'结束日期',
        type:'类型',
        week:'周',
        confirm_delete:'确认删除',
        batch_add:'批量添加',
	},
	debate:{
		add:'添加评估',
		date:'评估日期',
		view:'查看',
		del:'删除',
	},
	...zhLocale
}
export default cn;


// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js